import { z } from 'zod';

export const KNOWN_BLOCK_TYPES = [
  'hero',
  'features',
  'about',
  'cta',
  'footer',
  'departments',
  'doctorProfile',
  'clinicHours',
  'access',
  'news',
  'menu_list',
  'business_hours',
  'reservation',
  'restaurant_access',
  'service_menu',
  'staff_profile',
  'gallery',
  'booking_cta',
  'before_after_slider',
  'product_grid',
  'store_info',
  'online_shop_cta',
  'promo',
  'retail_access',
  'officeProfile',
  'practice',
  'cases',
  'consultationCTA',
  'lawNews',
] as const;

export type KnownBlockType = (typeof KNOWN_BLOCK_TYPES)[number];

const SEMVER_RE = /^\d+\.\d+\.\d+$/;

const BlockOverrideSchema = z.object({
  blockType: z.enum(KNOWN_BLOCK_TYPES),
  file: z.string().min(1).max(255),
  css: z.string().min(1).max(255).optional(),
});

const AssetEntrySchema = z.object({
  file: z.string().min(1).max(255),
});

export const TemplateManifestSchema = z.object({
  schemaVersion: z
    .string()
    .regex(SEMVER_RE, 'schemaVersion must be semver (e.g. "1.0.0")')
    .default('1.0.0'),
  name: z.string().min(1).max(80),
  version: z.string().regex(SEMVER_RE, 'version must be semver (e.g. "1.0.0")'),
  author: z.string().max(120).optional(),
  description: z.string().max(500).optional(),
  blockOverrides: z.array(BlockOverrideSchema).min(1),
  assets: z.array(AssetEntrySchema).max(20).optional(),
});

export type TemplateManifest = z.infer<typeof TemplateManifestSchema>;

export type CustomTemplateStatus = 'pending' | 'validating' | 'active' | 'invalid';
